// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"140":"82625ea94b9f0929","913":"82625ea94b9f0929","9229":"82625ea94b9f0929"}[chunkId] + ".css";
};